import { texteHtmlMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [texteHtmlMock('confidentialite')];

export const confidentialiteMock: SlugPage = {
  ...pageBase({
    title: 'Politique de confidentialité',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
